import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Col, Modal, Row, Tabs,} from 'antd';
import { initToothSample, ToothSample, User } from '../../../models';
import { AItem } from '../../../components/sample/AItem';
import { BItem } from '../../../components/sample/BItem';
import { HospitalPerson } from '../components/HospitalPerson';
import { loginInfo } from '../../../config';
import { buildSampleResult } from '../../../common';
interface PropsType {
  visible: boolean;
  add: Function;
  setInvisible: Function;
}

export const HospitalFillin: React.FC<PropsType> = ({ visible, add, setInvisible, }) => {
  const editRecord = initToothSample;
  const [age, setAge] = useState(5);
  /*useEffect(() => {
    setYear(moment().diff(moment(editRecord.birthday), "years"));
  }, [editRecord]);*/
  const handlerOk = async () => {
    //let sample: ToothSample = await getTable("toothsample",editRecord.id);
    let sample:ToothSample = {...editRecord};
    sample.fillinId = loginInfo.user.id;
    sample.fillinName = loginInfo.user.userName;
    sample.fillinDate = moment().format("YYYY-MM-DD HH:mm:ss");
    sample.status = "数据填报";
    sample.type = 1;
    if(sample.cat >= 0){
      sample.status = "检测";
      buildSampleResult(sample);
    }
    add(sample);
    setInvisible();
  }
  const handlerCancel = () => {
    setInvisible();
  }

  return (
    <>
      <Modal
        title="医院检测数据填报"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText='保存'
        cancelText='取消'
        width="80vw"
      >
        
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="受检人信息" key="1">
            <HospitalPerson editRecord={editRecord} setAge={setAge} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="生物学因素" key="2">
            <AItem editRecord={editRecord} age={age} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="保护性因素" key="3">
            <BItem editRecord={editRecord} />
          </Tabs.TabPane>
        </Tabs>
        
      </Modal>

    </>
  )
};